export default {
    provinces: 'provinces',
    provincesTitle: 'Title',
    provincesStatus: 'Status',
    editProvinces: 'Edit provinces',
    addProvinces: 'New provinces',
    countries: 'search Provinces By Countries',
    countriesTitle: 'countries',
}